import { render } from "./AlertsPane.vue?vue&type=template&id=33d539aa"
import script from "./AlertsPane.vue?vue&type=script&lang=js"
export * from "./AlertsPane.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__